import { resetSessionKeys } from "Utils";
import ReservationService from "Services/reservation.service";

function cleanupLastReservationSession() {
    resetSessionKeys([
        ReservationService.BOOKED_RESERVATION,
        ReservationService.SELECT_AVAILABILITY_STATE,
        ReservationService.APPLIED_POINTS,
        ReservationService.CONTRACT_TOOL_TIPS,
        ReservationService.USAGE_REQUIRED_BY_DAY,
        ReservationService.SELECTED_PREFERENCES,
        ReservationService.ALTERNATE_SEARCH_RESORT
    ]);
};

export {
    cleanupLastReservationSession,
};